<template>
    <v-container fluid>
        <!-- Ajout des Tabs pour basculer entre Tutoriels et Modules -->
        <v-tabs v-model="activeTab" style="border-radius: 12px">
            <v-tab value="Tutorials" ripple>Tutoriels</v-tab>
            <v-tab value="Modules" ripple>Modules</v-tab>
        </v-tabs>

        <v-window v-model="activeTab">
            <!-- SECTION TUTORIELS -->
            <v-window-item value="Tutorials">
                <h1>Suivi d'avancement des tutoriels</h1>
                <v-divider class="my-3" />
                <v-row>
                    <v-col v-if="enableWrite">
                        <v-select
                            v-model="selectedCompanyId"
                            :items="allAvailableCompanies"
                            label="Sélectionner une entreprise"
                            :item-title="(item) => item.key"
                            item-value="value"
                            dense
                            outlined
                            hide-details
                            clearable
                            density="compact"
                        />
                    </v-col>
                    <v-col>
                        <v-select
                            v-model="selectedUsers"
                            :items="users"
                            label="Utilisateurs"
                            :item-title="(item: any) => item.key"
                            item-value="value"
                            multiple
                            dense
                            small-chips
                            outlined
                            hide-details
                            clearable
                            density="compact"
                            style="
                                flex-wrap: wrap;
                                max-width: 100%;
                                overflow-y: auto;
                                max-height: 100px;
                            "
                            ref="userSelect"
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index < 1" :key="item.value" size="x-small">
                                    {{ item.title }}
                                </v-chip>
                                <v-chip v-if="index === 1" :key="'more-users'" size="x-small">
                                    + {{ selectedUsers.length - 1 }} autres
                                </v-chip>
                            </template>
                        </v-select>
                        <!-- Faire point avec Romain pour bien placer  -->
                        <!-- <v-menu
                            v-model="menu.userMenu"
                            :close-on-content-click="false"
                            offset-y
                            :activator="userSelectEl"
                            ref="userMenu"
                        >
                            <v-row class="px-2">
                                <v-btn
                                    text
                                    small
                                    @click="selectAllUsers"
                                >
                                    Sélectionner tout
                                </v-btn>
                                <v-btn
                                    text
                                    small
                                    @click="deselectAllUsers"
                                >
                                    Désélectionner tout
                                </v-btn>
                            </v-row>
                        </v-menu> -->
                    </v-col>
                    <v-col>
                        <v-select
                            v-model="selectedCategories"
                            :items="allCategories"
                            :item-title="(item: any) => item.text"
                            item-value="value"
                            label="Catégories de tutoriels"
                            multiple
                            small-chips
                            outlined
                            hide-details
                            clearable
                            density="compact"
                            style="
                                flex-wrap: wrap;
                                max-width: 100%;
                                overflow-y: auto;
                                max-height: 100px;
                            "
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index < 1" :key="item.value" size="x-small">
                                    {{ item.title }}
                                </v-chip>
                                <v-chip v-if="index === 1" :key="'more-items'" size="x-small">
                                    + {{ selectedCategories.length - 1 }} autres
                                </v-chip>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col>
                        <v-select
                            v-model="selectedStatus"
                            :items="statusOptions"
                            label="Statut"
                            density="compact"
                            outlined
                            hide-details
                            clearable
                        >
                        </v-select>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-card rounded="xl" elevation="0" class="mt-2">
                            <v-card-title class="d-flex align-center">
                                &#xc9;tat d'avancement des tutoriels
                                <v-spacer />
                                <v-btn
                                    color="primary"
                                    class="elevation-0"
                                    rounded
                                    dense
                                    dark
                                    @click="refreshChart"
                                >
                                    Actualiser
                                </v-btn>
                            </v-card-title>
                            <v-container class="px-0">
                                <bar-chart
                                    v-if="chartDataReady"
                                    :data="chartData"
                                    :options="chartOptions"
                                    :height="$vuetify.display.mobile ? 200 : 300"
                                />
                            </v-container>
                            <v-container
                                v-if="selectedUsers.length === 1 && filteredTutorials.length"
                                class="px-0"
                            >
                                <v-data-table
                                    :headers="tutorialTableHeaders"
                                    :items="filteredTutorials"
                                    item-key="learningObjectId"
                                    class="elevation-1 table"
                                >
                                    <template v-slot:item.progress="{ item }">
                                        <v-progress-circular
                                            v-if="!isTutorialCompleted(item)"
                                            :model-value="calculateProgress(item)"
                                            color="primary"
                                            size="24"
                                            width="3"
                                            rounded
                                        />
                                        <v-icon v-else size="24" width="3" color="primary">
                                            $oss-circle-check
                                        </v-icon>
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card>
                    </v-col>
                </v-row>
            </v-window-item>

            <!-- SECTION MODULES -->
            <v-window-item value="Modules">
                <h1>Suivi d'avancement des modules</h1>
                <v-divider class="my-3" />
                <v-row>
                    <v-col v-if="enableWrite">
                        <v-select
                            v-model="selectedCompanyId"
                            :items="allAvailableCompanies"
                            label="Sélectionner une entreprise"
                            :item-title="(item) => item.key"
                            item-value="value"
                            density="compact"
                            outlined
                            hide-details
                            clearable
                        />
                    </v-col>
                    <v-col>
                        <v-select
                            v-model="selectedUsersForModules"
                            :items="users"
                            label="Utilisateurs"
                            :item-title="(item) => item.key"
                            item-value="value"
                            multiple
                            density="compact"
                            small-chips
                            outlined
                            hide-details
                            clearable
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index < 1" :key="item.value" size="x-small">
                                    {{ item.title }}
                                </v-chip>
                                <v-chip v-if="index === 1" :key="'more-users'" size="x-small">
                                    + {{ selectedUsersForModules.length - 1 }} autres
                                </v-chip>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col>
                        <v-select
                            v-model="selectedModules"
                            :items="allModules"
                            label="Modules"
                            :item-title="(item) => item.name"
                            item-value="id"
                            multiple
                            density="compact"
                            small-chips
                            outlined
                            hide-details
                            clearable
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index < 1" :key="item.value" size="x-small">
                                    {{ item.title }}
                                </v-chip>
                                <v-chip v-if="index === 1" :key="'more-items'" size="x-small">
                                    + {{ selectedModules.length - 1 }} autres
                                </v-chip>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12">
                        <v-card rounded="xl" elevation="0" class="mt-2">
                            <v-card-title class="d-flex align-center">
                                &#xc9;tat d'avancement des modules
                                <v-spacer />
                                <v-btn
                                    color="primary"
                                    class="elevation-0"
                                    rounded
                                    dense
                                    dark
                                    @click="refreshModuleChart"
                                    >Actualiser</v-btn
                                >
                            </v-card-title>
                            <v-container>
                                <bar-chart
                                    v-if="moduleChartDataReady"
                                    :data="moduleChartData"
                                    :options="chartOptions"
                                    :height="$vuetify.display.mobile ? 200 : 300"
                                />
                            </v-container>
                            <v-container
                                v-if="
                                    selectedUsersForModules.length === 1 && filteredModules.length
                                "
                            >
                                <v-data-table
                                    :headers="moduleTableHeaders"
                                    :items="filteredModules"
                                    item-key="moduleId"
                                    class="elevation-1 table"
                                >
                                    <template v-slot:item.progress="{ item }">
                                        <v-progress-circular
                                            v-if="!isModuleCompleted(item)"
                                            :model-value="calculateModuleProgress(item.id)"
                                            color="primary"
                                            size="24"
                                            width="3"
                                            rounded
                                        />
                                        <v-icon
                                            v-if="isModuleCompleted(item)"
                                            size="24"
                                            width="3"
                                            color="primary"
                                        >
                                            $oss-circle-check
                                        </v-icon>
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card>
                    </v-col>
                </v-row>
            </v-window-item>
        </v-window>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";
import { Bar as BarChart } from "vue-chartjs";
import COMPANY_USERS from "../../graphql/user/PartOfCompanyUsers.gql";
import MODULES_PROGRESS from "../../graphql/tutorials/ModulesProgress.gql";
import TUTORIALS from "../../graphql/tutorials/Tutorials.gql";
import TUTORIALS_PROGRESS from "../../graphql/tutorials/TutorialsProgress.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { uniq } from "lodash";
import { gql } from "@apollo/client";

@Component({
    components: {
        BarChart,
    },
})
export class TutorialsProgress extends Vue {
    selectedUsers: Array<any> = [];
    selectedCompanyId: string | null = null;
    selectedUsersForModules: Array<any> = [];
    selectedModules: Array<any> = [];
    selectedCategories: Array<any> = [];
    selectedStatus: string | null = null;
    chartDataReady = false;
    moduleChartDataReady = false;

    activeTab = "Tutorials";

    menu: { [key: string]: boolean } = {
        userMenu: false,
        categoryMenu: false,
    };

    userColors: { [key: string]: string } = {};

    fixedColors: Array<string> = [
        "#F44336",
        "#E91E63",
        "#9C27B0",
        "#673AB7",
        "#3F51B5",
        "#2196F3",
        "#03A9F4",
        "#00BCD4",
        "#009688",
        "#4CAF50",
        "#8BC34A",
        "#CDDC39",
        "#FFEB3B",
        "#FFC107",
        "#FF9800",
        "#FF5722",
        "#795548",
        "#9E9E9E",
        "#607D8B",
        "#000000",
    ];

    beforeMount() {
        if (this.selectedCategories.length === 0) {
            this.selectedCategories = this.referencedPaths.map((path) => {
                return {
                    text: this.formatFolderTitle(path as any),
                    value: path,
                };
            });
        }
    }

    // *** GETTERS ***
    get statusOptions() {
        return ["Pas commencé", "En cours", "Terminé"];
    }

    get allCategories() {
        return [
            ...this.referencedPaths.map((path) => {
                return {
                    text: this.formatFolderTitle(path as any),
                    value: path,
                };
            }),
        ];
    }

    get currentUser() {
        return this.$store.state.user;
    }

    /****
     * Returns the company ID of the current user.
     * If the current user does not have a company, it returns null.
     ****/
    get companyId() {
        if (this.selectedCompanyId) {
            return this.selectedCompanyId;
        } else {
            if (this.currentUser?.company?.id) {
                return this.currentUser.company.id;
            }
        }
        return null;
    }

    /**
     * Retrieves the list of referenced paths from the tutorials.
     * This method extracts unique paths from the tutorial objects.
     * @returns An array of referenced paths.
     **/
    get referencedPaths() {
        if (this.tutorials) {
            return uniq(this.tutorials.flatMap((t: any) => (t.path ? t.path.split(";") : [])));
        } else {
            return [];
        }
    }

    /** Determines if the current user has permissions.
     * @returns A boolean indicating if write permissions are enabled.
     */
    get enableWrite() {
        if (this.currentUser.isRoot) {
            return true;
        }
        // if (this.currentUser.email?.endsWith("@oss360.com") || this.currentUser.email?.endsWith("@bobbeelab.com")) {
        //     return true;
        // }
        return false;
    }

    get allAvailableCompanies() {
        const companies = [];
        this.currentUser.allAvailableCompanies.forEach((company) => {
            companies.push({
                value: company.id,
                key: company.name,
            });
            companies.sort((a, b) => {
                if (a.key < b.key) return -1;
                if (a.key > b.key) return 1;
                return 0;
            });
        });

        return companies;
    }

    get allModules() {
        return this.modules.map((module) => ({
            id: module.id,
            name: module.name,
        }));
    }

    get chartData() {
        // Regrouper les tutoriels par catégorie
        const groupedByCategory = this.selectedCategories.reduce((acc, category) => {
            acc[category] = [];
            return acc;
        }, {});

        this.tutorials.forEach((tutorial) => {
            const paths = tutorial.path ? tutorial.path.split(";") : [];
            paths.forEach((path) => {
                if (this.selectedCategories.includes(path)) {
                    if (!groupedByCategory[path]) {
                        groupedByCategory[path] = [];
                    }
                    groupedByCategory[path].push(tutorial);
                }
            });
        });

        // Filtrer et calculer la progression moyenne pour chaque catégorie
        const categoryProgress = Object.keys(groupedByCategory).map((category) => {
            const tutorialsInCategory = groupedByCategory[category].filter((tutorial) => {
                const progress = this.calculateProgress(tutorial);

                let inSelectedStatus = true;
                if (this.selectedStatus === "Pas commencé") {
                    inSelectedStatus = progress === 0;
                } else if (this.selectedStatus === "En cours") {
                    inSelectedStatus = progress > 0 && progress < 100;
                } else if (this.selectedStatus === "Terminé") {
                    inSelectedStatus = progress === 100;
                }
                return inSelectedStatus;
            });

            const averageProgress =
                tutorialsInCategory.reduce((acc, tutorial) => {
                    return acc + this.calculateProgress(tutorial);
                }, 0) / (tutorialsInCategory.length || 1);

            return {
                category,
                progress: Math.round(averageProgress),
            };
        });

        // Préparer les labels et datasets pour le graphique
        const labels = categoryProgress.map((item) => this.formatFolderTitle(item.category));
        const datasets = this.selectedUsers.map((userId, index) => {
            if (!this.userColors[userId]) {
                this.userColors[userId] = this.fixedColors[index % this.fixedColors.length];
            }
            return {
                label: this.users.find((u) => u.value === userId)?.key,
                data: categoryProgress.map((item) => item.progress),
                backgroundColor: this.userColors[userId] || this.getRandomColor(),
            };
        });

        return {
            labels,
            datasets,
        };
    }

    /****
     * Returns the options for the bar chart.
     * This method sets the chart options, such as the legend position, the y-axis range, and the responsiveness.
     ****/
    get chartOptions() {
        return {
            indexAxis: "y", // Inverser les axes pour un graphique à barres horizontales
            plugins: {
                legend: {
                    position: "bottom",
                    display: true,
                },
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {
                    beginAtZero: true,
                    max: 100, // Limiter l'axe des X à 100%
                    ticks: {
                        stepSize: 10, // Afficher les pourcentages de 10 en 10
                        callback: (value: number) => `${value}%`, // Formater les ticks en pourcentage
                    },
                },
                y: {
                    grid: {
                        // Supprimer la grille horizontale
                        display: false,
                    },
                },
            },
        };
    }

    /****
     * Generates the table headers for the data table.
     ****/
    get tutorialTableHeaders() {
        return [
            { title: "Nom du tutoriel", value: "learningObjectName" },
            { title: "Chemin", value: "learningObjectPath" },
            { title: "Description", value: "learningObjectDescription" },
            { title: "Pourcentage de complétion", value: "progressPercentage" },
            { title: "Statut", value: "progress" },
        ];
    }

    get moduleChartData() {
        const labels = this.selectedModules.map((moduleId) => {
            const module = this.modules.find((mod) => mod.id === moduleId);
            return module ? module.name : "";
        });

        const datasets = this.selectedUsersForModules.map((userId, index) => {
            return {
                label: this.users.find((user) => user.value === userId)?.key,
                data: this.selectedModules.map((moduleId) =>
                    this.calculateModuleProgress(moduleId, userId),
                ),
                backgroundColor: this.getRandomColor(),
            };
        });

        return { labels, datasets };
    }

    get moduleTableHeaders() {
        return [
            { title: "Nom du module", value: "moduleName" },
            { title: "Description", value: "moduleDescription" },
            { title: "Pourcentage de complétion", value: "progressPercentage" },
            { title: "Statut", value: "progress" },
        ];
    }

    /**
     * Filters the tutorials for the selected categories and status,
     * while mapping the output to include the necessary fields.
     */
    get filteredTutorials() {
        let filteredTutorials = this.tutorials;

        // Filtrer les tutoriels en fonction des catégories sélectionnées
        if (this.selectedCategories?.length !== this.allCategories?.length) {
            filteredTutorials = filteredTutorials.filter((tutorial) => {
                const paths = tutorial.path ? tutorial.path.split(";") : [];
                return this.selectedCategories.some((category) => paths.includes(category));
            });
        }

        // Filtrer les tutoriels en fonction du statut sélectionné
        if (this.selectedStatus) {
            filteredTutorials = filteredTutorials.filter((tutorial) => {
                const progress = this.calculateProgress(tutorial);
                if (this.selectedStatus === "Pas commencé" && progress > 0) return false;
                if (this.selectedStatus === "En cours" && (progress === 0 || progress === 100))
                    return false;
                if (this.selectedStatus === "Terminé" && progress < 100) return false;
                return true;
            });
        }

        // Mapper les tutoriels filtrés pour inclure les informations de progression et autres détails
        return filteredTutorials.map((tutorial) => {
            const progress = this.calculateProgress(tutorial);
            return {
                id: tutorial.id,
                learningObjectName: tutorial.name,
                learningObjectPath: this.formatFolderTitle(tutorial.path).endsWith(";")
                    ? this.formatFolderTitle(tutorial.path).slice(0, -1)
                    : this.formatFolderTitle(tutorial.path),
                learningObjectDescription: tutorial.description || "N/A",
                progressPercentage: `${Math.round(progress)} %`,
                learningObjectId: tutorial.id,
            };
        });
    }

    get filteredModules() {
        return this.selectedModules.map((moduleId) => {
            const progress = this.calculateModuleProgress(moduleId);
            const module = this.modules.find((mod) => mod.id === moduleId);
            return {
                id: module?.id || "",
                moduleName: module?.name || "N/A",
                moduleDescription: module?.description || "N/A",
                progressPercentage: `${Math.round(progress)} %`,
            };
        });
    }

    /****
     * Apollo query to fetch the list of users for the current company.
     * This query retrieves users' IDs and names, which are used to populate the user selection dropdown.
     ****/
    @Apollo({
        query: COMPANY_USERS,
        variables() {
            return {
                companyId: this.companyId,
                email_not: null,
            };
        },
        skip() {
            return !this.companyId;
        },
        result({ data, loading }) {
            if (!loading && data) {
                this.users = data.users.map((user) => ({
                    value: user.id,
                    key: user.firstname + " " + user.lastname,
                }));
            }
        },
    })
    users = [];

    /****
     * Apollo query to fetch the progress of tutorials for selected users and categories.
     * This query retrieves the progress data, which is then used to generate the bar chart.
     ****/
    @Apollo({
        query: TUTORIALS_PROGRESS,
        variables() {
            return {
                companyId: this.companyId,
                selectedUsers: this.selectedUsers || [],
                selectedCategories: this.selectedCategories.includes("Tous")
                    ? this.referencedPaths.map((category) => category + ";")
                    : this.selectedCategories.map((category) => category + ";"),
            };
        },
        skip() {
            return !this.companyId || !this.selectedUsers.length || !this.selectedCategories.length;
        },
        result({ data, loading }) {
            if (!loading && data) {
                if (data?.tutorialsProgress?.progress) {
                    this.tutorialsProgress = data.tutorialsProgress?.progress;
                } else {
                    this.tutorialsProgress = [];
                }
                this.chartDataReady = true;
            }
        },
    })
    tutorialsProgress = [];

    /****
     * Apollo query to fetch the list of tutorials.
     * This query retrieves the tutorials based on stored tutorial IDs or a search string.
     ****/
    @Apollo({
        query() {
            return TUTORIALS;
        },
        variables() {
            if (this.starterComponents && this.storedTutorialIds?.length) {
                return {
                    ids: this.storedTutorialIds,
                };
            }
            return {
                search: this.search,
            };
        },
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.tutorialsByIds?.tutorials) {
                    this.tutorials = data.tutorialsByIds.tutorials;
                } else {
                    if (data?.tutorials?.tutorials) {
                        this.tutorials = data.tutorials.tutorials;
                    } else {
                        this.tutorials = [];
                    }
                }
            }
        },
    })
    tutorials: any = [];

    /****
     * Apollo query to fetch the list of modules.
     * This query retrieves the modules based on the company ID.
     ****/
    @Apollo({
        query: gql`
            query GetAllModules {
                learningModules {
                    id
                    name
                    description
                    createdAt
                    updatedAt
                    learningObjects {
                        id
                        name
                        stepCount
                        description
                    }
                }
            }
        `,
        result({ data, loading }) {
            if (!loading && data) {
                this.modules = data.learningModules || [];
            }
        },
    })
    modules: Array<any> = [];

    @Apollo({
        query: MODULES_PROGRESS,
        variables() {
            return {
                companyId: this.companyId,
                selectedUsers: this.selectedUsersForModules,
                selectedModules: this.selectedModules,
            };
        },
        skip() {
            return !this.selectedUsersForModules.length || !this.selectedModules.length;
        },
        result({ data, loading }) {
            if (!loading && data) {
                this.modulesProgress = data?.modulesProgress?.progress || [];
                this.moduleChartDataReady = true;
            }
        },
    })
    modulesProgress: Array<any> = [];

    // *** WATCHERS ***
    @Watch("selectedUsers")
    @Watch("selectedCategories")
    @Watch("selectedStatus")
    onSelectionChanged() {
        this.chartDataReady = false;
        this.fetchTutorialsProgress();
    }

    /****
     * Refetches the tutorials progress data.
     * This method is called when the user or category selection changes.
     ****/
    fetchTutorialsProgress() {
        this.$apollo.queries.tutorialsProgress.refetch();
        this.$apollo.queries.tutorialsProgress.refetch();
    }

    /** Refresh tutorials chart data */
    async refreshChart() {
        this.chartDataReady = false;
        await this.$apollo.queries.tutorialsProgress.refetch();
    }

    /** Refresh modules chart data */
    async refreshModuleChart() {
        this.moduleChartDataReady = false;
        await this.$apollo.queries.modulesProgress.refetch();
    }

    /****
     * Generates a random color in hexadecimal format.
     * This method is used to assign different colors to each user's dataset in the bar chart.
     ****/
    getRandomColor() {
        const letters = "0123456789ABCDEF";
        let color = "#";
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    /****
     * Calculates the progress percentage for a specific tutorial and user.
     * @param tutorial The tutorial object.
     * @returns The progress percentage.
     ****/
    calculateProgress(tutorial) {
        const userId = this.selectedUsers[0];
        const progress = this.tutorialsProgress.find(
            (progress) => progress.learningObjectId === tutorial.id && progress.userId === userId,
        );
        return progress ? Math.round(progress.progressPercentage) : 0;
    }

    /****
     * Calculate module progress percentage
     * @param moduleId The module ID
     * @param userId The user ID
     * ****/
    calculateModuleProgress(moduleId: string, userId?: string) {
        const user = userId || this.selectedUsersForModules[0];
        const moduleProgress = this.modulesProgress.find(
            (progress) => progress.learningModuleId === moduleId && progress.userId === user,
        );
        return moduleProgress?.progressPercentage
            ? moduleProgress.progressPercentage.toFixed(0)
            : 0;
    }

    /****
     * Checks if a specific tutorial is completed by a user.
     * @param tutorial The tutorial object.
     * @returns True if the tutorial is completed, false otherwise.
     ****/
    isTutorialCompleted(tutorial) {
        const userId = this.selectedUsers[0];
        const progress = this.tutorialsProgress.find(
            (progress) => progress.learningObjectId === tutorial.id && progress.userId === userId,
        );
        return progress ? progress.progressPercentage === 100 : false;
    }

    /****
     * Checks if a specific tutorial is completed by a user.
     * @param tutorial The tutorial object.
     * @returns True if the tutorial is completed, false otherwise.
     ****/
    isModuleCompleted(module) {
        const userId = this.selectedUsers[0];
        const progress = this.modulesProgress.find(
            (progress) => progress.learningModuleId === module.id && progress.userId === userId,
        );
        return progress ? progress.progressPercentage === 100 : false;
    }

    /** Formats the folder title by splitting on hyphens and rejoining.
     * @param folderName The folder name to format.
     * @returns The formatted folder title.
     */
    formatFolderTitle(folderName: string) {
        let name = folderName.split("-");
        if (name.length > 1) {
            return name.slice(1).join(" ");
        }
        return name.join(" ");
    }

    toggleMenu(menuName: "userMenu" | "categoryMenu") {
        this.menu[menuName] = !this.menu[menuName];
    }

    selectAllUsers() {
        this.selectedUsers = this.users.map((user) => user.value);
        this.menu.userMenu = false;
    }

    deselectAllUsers() {
        this.selectedUsers = [];
        this.menu.userMenu = false;
    }

    selectAllCategories() {
        this.selectedCategories = this.allCategories.map((category) => category.value);
        this.menu.categoryMenu = false;
    }

    deselectAllCategories() {
        this.selectedCategories = [];
        this.menu.categoryMenu = false;
    }
}

export default toNative(TutorialsProgress);
</script>
